/*
 * VFD – Mængderabat (produktside og quick view)
 * Markerer det aktive rabattrin, viser totalpris og besparelse,
 * og lader kunden klikke på et trin for at vælge det antal.
 * Bruger event delegation, så det også virker, når temaet
 * genindlæser prisblokken ved variantskift.
 */
(function () {
  if (window.VFDVolumePricing) return;

  function formatMoney(cents) {
    var format = (window.KROWN && KROWN.settings && KROWN.settings.shop_money_format) || '{{amount_with_comma_separator}} kr';
    var value = (cents / 100);
    function fmt(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount_with_comma_separator';
    var out;
    switch (key) {
      case 'amount': out = fmt(value, 2, ',', '.'); break;
      case 'amount_no_decimals': out = fmt(value, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(value, 0, '.', ','); break;
      case 'amount_with_period_and_space_separator': out = fmt(value, 2, ' ', '.'); break;
      default: out = fmt(value, 2, '.', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function update(widget, qty) {
    var tiers = Array.prototype.slice.call(widget.querySelectorAll('[data-vfd-tier]'));
    var base = parseInt(widget.dataset.base, 10);
    var unit = base;
    var active = null;

    tiers.forEach(function (t) {
      if (qty >= parseInt(t.dataset.min, 10)) {
        active = t;
        unit = parseInt(t.dataset.price, 10);
      }
    });
    tiers.forEach(function (t) {
      var on = t === active;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var qtyEl = widget.querySelector('[data-vfd-qty]');
    var totalEl = widget.querySelector('[data-vfd-total]');
    var savingEl = widget.querySelector('[data-vfd-saving]');
    var nextEl = widget.querySelector('[data-vfd-next]');

    if (qtyEl) qtyEl.textContent = qty;
    if (totalEl) totalEl.textContent = formatMoney(unit * qty);
    if (savingEl) {
      var saving = (base - unit) * qty;
      savingEl.hidden = saving <= 0;
      savingEl.textContent = saving > 0 ? 'Du sparer ' + formatMoney(saving) : '';
    }
    if (nextEl) {
      var next = tiers.filter(function (t) { return parseInt(t.dataset.min, 10) > qty; })[0];
      nextEl.hidden = !next;
      if (next) {
        nextEl.textContent = 'Køb ' + (parseInt(next.dataset.min, 10) - qty) + ' fl. mere og betal ' + formatMoney(parseInt(next.dataset.price, 10)) + ' pr. fl.';
      }
    }
  }

  function widgetsFor(input) {
    if (!input || !input.id) return [];
    return Array.prototype.slice.call(document.querySelectorAll('[data-vfd-vp][data-qty-input="' + input.id + '"]'));
  }

  function refreshAll() {
    document.querySelectorAll('[data-vfd-vp]').forEach(function (w) {
      var input = document.getElementById(w.dataset.qtyInput);
      if (input) update(w, parseInt(input.value, 10) || 1);
    });
  }

  // Antal ændret via +/- eller indtastning
  document.addEventListener('vfd:quantity', function (e) {
    var qty = (e.detail && e.detail.quantity) || parseInt(e.target.value, 10) || 1;
    widgetsFor(e.target).forEach(function (w) { update(w, qty); });
  });

  // Klik på et rabattrin vælger det antal
  document.addEventListener('click', function (e) {
    var tier = e.target.closest && e.target.closest('[data-vfd-tier]');
    if (!tier) return;
    var widget = tier.closest('[data-vfd-vp]');
    var input = widget && document.getElementById(widget.dataset.qtyInput);
    var min = parseInt(tier.dataset.min, 10);
    if (input) {
      input.value = min;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      update(widget, min);
    }
  });

  // Temaet genindlæser prisblokken ved variantskift – opdater så den nye blok
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-vfd-vp]') || n.querySelector('[data-vfd-vp]'))) {
          refreshAll();
          return;
        }
      }
    }
  });

  function start() {
    refreshAll();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.VFDVolumePricing = { refresh: refreshAll };
})();

/*
 * VFD – Pris-sortering for erhvervskunder.
 * Shopify sorterer efter butikspriser; for erhvervskunder sorterer vi kortene på siden
 * efter den pris, kortet viser (B2B-katalogprisen), når der er valgt pris-sortering.
 */
(function () {
  if (!window.VFD_B2B || window.VFDB2BSort) return;
  var busy = false;

  function sortGrid() {
    var grid = document.getElementById('CollectionProductGrid');
    if (!grid || busy) return;
    // valgt sortering i adressen, ellers kategoriens standardsortering
    var sortBy = new URLSearchParams(window.location.search).get('sort_by') || window.VFD_SORT || '';
    var dir = sortBy === 'price-ascending' ? 1 : (sortBy === 'price-descending' ? -1 : 0);
    if (!dir) return;
    // kortene kan ligge i en indre boks (fx når filtrene står i venstre side)
    var first = grid.querySelector('[data-vfd-price]');
    if (!first) return;
    var box = first.parentElement;
    var items = Array.prototype.filter.call(box.children, function (el) {
      return el.matches && el.matches('[data-vfd-price]');
    });
    if (items.length < 2) return;
    var sorted = items.slice().sort(function (a, b) {
      return dir * (parseInt(a.dataset.vfdPrice, 10) - parseInt(b.dataset.vfdPrice, 10));
    });
    var changed = sorted.some(function (el, i) { return el !== items[i]; });
    if (!changed) return;
    busy = true;
    var anchor = items[items.length - 1].nextSibling;
    sorted.forEach(function (el) { box.insertBefore(el, anchor); });
    busy = false;
  }

  function start() {
    sortGrid();
    var wrap = document.getElementById('CollectionProductGrid');
    if (wrap && wrap.parentNode) {
      new MutationObserver(function () { if (!busy) setTimeout(sortGrid, 0); })
        .observe(wrap.parentNode, { childList: true, subtree: true });
    }
    window.addEventListener('popstate', function () { setTimeout(sortGrid, 50); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.VFDB2BSort = { sort: sortGrid };
})();
